import { Stack } from "@mui/material"
import { FC } from "react"
import Chart from 'react-apexcharts'
import { ChartSeries, useContentChart } from "../../../presenter/useContentChart";

interface IProps {
    chartSeries: ChartSeries;
};

export const ChartBody: FC<IProps> = ({ chartSeries }) => {
    const chartOptions = useContentChart();

    return (
        <Chart
            height={320}
            width="100%"
            options={chartOptions}
            series={chartSeries}
            type="line"
        />
    )
}